import { createFileRoute } from "@tanstack/react-router";
import AvMedInsurance, { config } from "@/pages/AvMedInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/avmed-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "AvMed TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have AvMed insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your AvMed plan in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "AvMed TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have AvMed insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your AvMed plan in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/avmed-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/avmed-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AvMedInsurance />;
}
